import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import Cta from './Components/Cta/Cta'
import Features from './Components/Features/Features'
import Hero from './Components/Hero/Hero'
import Quote from './Components/Quote/Quote'

function BusinessAccount({ copy }) {
  return (
    <div className="business-account">
      <Hero hero={copy.hero} form={copy.form} />
      <Features features={copy.features} />
      <Quote quote={copy.quote} />
      <Cta cta={copy.cta} />
    </div>
  )
}

BusinessAccount.propTypes = {
  copy: shape({
    hero: shape({ title: string.isRequired }).isRequired,
    form: shape({ title: string.isRequired }).isRequired,
    features: arrayOf(shape({ title: string.isRequired })).isRequired,
    quote: shape({ text: string.isRequired }).isRequired,
    cta: shape({ title: string.isRequired }).isRequired,
  }).isRequired,
}

export default BusinessAccount
